/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AutoFinalizeLetters } from '@coin/shared/core/util-models-v2';
import { AutoFinalizeLettersByQuery } from '@coin/shared/core/util-models-v2';
import { CreateLetterBatch } from '@coin/shared/core/util-models-v2';
import { CreateLetterBulk } from '@coin/shared/core/util-models-v2';
import { DownloadLetters } from '@coin/shared/core/util-models-v2';
import { ForwardLetters } from '@coin/shared/core/util-models-v2';
import { PageOfWorkflowTemplate } from '@coin/shared/core/util-models-v2';
import { PublishLetterBatch } from '@coin/shared/core/util-models-v2';
import { PublishLetterList } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfLetterBatchMetadata } from '@coin/shared/core/util-models-v2';
import { UnpublishLetterBatch } from '@coin/shared/core/util-models-v2';
import { UnpublishLetterList } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface CommunicationsPartnerAutoFinalizeLettersByQueryLetterFinalizationParams {
  id?: Array<string>;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  orgClusterNodeName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  letterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  templateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  processStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  recordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  workflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  template?: Array<string>;
  isDesignReady?: boolean;
  payoutDate?: string;
  payoutState?: Array<'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  seasonId?: string;
  workflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  multiplier?: number;
  overallTargetAchievement?: number;
  payoutAmount?: number;
  payoutCurrency?: Array<string>;
  ippAchievementValue?: string;
  incentivePaymentType?: Array<string>;
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  measurementDate?: string;
  meritTitle?: Array<string>;
  equityTitle?: Array<string>;
  equitySubTitle?: Array<string>;
  manuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  newHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  promotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  termination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  populationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  lineManagerFirstName?: Array<string>;
  lineManagerLastName?: Array<string>;
  companyManagerFirstName?: Array<string>;
  companyManagerGid?: Array<string>;
  companyManagerLastName?: Array<string>;
  templateName?: Array<string>;
  workflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  autoApprove?: boolean;
  approvalRequired?: boolean;
  letterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  processState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  exportState?: Array<'Open' | 'Done'>;
  payrollState?: Array<'Open' | 'Done'>;
  meritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  approvedByCompanyManager?: boolean;
  allocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  readyToPayroll?: boolean;
  equityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  hasOtpIncrease?: boolean;
  isOtpOnly?: boolean;
  planTitle?: Array<string>;
  localCurrency?: Array<string>;
  proposalAmount?: number;
  proposalAmountInEuro?: number;
  proposalDate?: string;
  proposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  specialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  specialPaymentCompensationType?: Array<'Unknown' | 'Cash' | 'Equity'>;
  templateLetterName?: Array<string>;
  autoFinalizeLettersByQuery?: AutoFinalizeLettersByQuery;
}

export interface CommunicationsPartnerAutoFinalizeLettersLetterFinalizationParams {
  autoFinalizeLetters?: AutoFinalizeLetters;
}

export interface CommunicationsPartnerBatchDownloadByQueryLettersParams {
  id?: Array<string>;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  orgClusterNodeName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  letterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  templateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  processStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  recordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  workflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  template?: Array<string>;
  isDesignReady?: boolean;
  payoutDate?: string;
  payoutState?: Array<'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  seasonId?: string;
  workflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  multiplier?: number;
  overallTargetAchievement?: number;
  payoutAmount?: number;
  payoutCurrency?: Array<string>;
  ippAchievementValue?: string;
  incentivePaymentType?: Array<string>;
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  measurementDate?: string;
  meritTitle?: Array<string>;
  equityTitle?: Array<string>;
  equitySubTitle?: Array<string>;
  manuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  newHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  promotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  termination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  populationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  lineManagerFirstName?: Array<string>;
  lineManagerLastName?: Array<string>;
  companyManagerFirstName?: Array<string>;
  companyManagerGid?: Array<string>;
  companyManagerLastName?: Array<string>;
  templateName?: Array<string>;
  workflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  autoApprove?: boolean;
  approvalRequired?: boolean;
  letterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  processState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  exportState?: Array<'Open' | 'Done'>;
  payrollState?: Array<'Open' | 'Done'>;
  meritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  approvedByCompanyManager?: boolean;
  allocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  readyToPayroll?: boolean;
  equityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  hasOtpIncrease?: boolean;
  isOtpOnly?: boolean;
  planTitle?: Array<string>;
  localCurrency?: Array<string>;
  proposalAmount?: number;
  proposalAmountInEuro?: number;
  proposalDate?: string;
  proposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  specialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  specialPaymentCompensationType?: Array<'Unknown' | 'Cash' | 'Equity'>;
  templateLetterName?: Array<string>;
  downloadLetters?: DownloadLetters;
}

export interface CommunicationsPartnerBatchUnpublishLetterLetterPublicationsParams {
  id?: Array<string>;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  orgClusterNodeName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  letterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  templateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  processStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  recordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  workflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  template?: Array<string>;
  isDesignReady?: boolean;
  payoutDate?: string;
  payoutState?: Array<'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  seasonId?: string;
  workflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  multiplier?: number;
  overallTargetAchievement?: number;
  payoutAmount?: number;
  payoutCurrency?: Array<string>;
  ippAchievementValue?: string;
  incentivePaymentType?: Array<string>;
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  measurementDate?: string;
  meritTitle?: Array<string>;
  equityTitle?: Array<string>;
  equitySubTitle?: Array<string>;
  manuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  newHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  promotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  termination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  populationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  lineManagerFirstName?: Array<string>;
  lineManagerLastName?: Array<string>;
  companyManagerFirstName?: Array<string>;
  companyManagerGid?: Array<string>;
  companyManagerLastName?: Array<string>;
  templateName?: Array<string>;
  workflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  autoApprove?: boolean;
  approvalRequired?: boolean;
  letterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  processState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  exportState?: Array<'Open' | 'Done'>;
  payrollState?: Array<'Open' | 'Done'>;
  meritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  approvedByCompanyManager?: boolean;
  allocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  readyToPayroll?: boolean;
  equityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  hasOtpIncrease?: boolean;
  isOtpOnly?: boolean;
  planTitle?: Array<string>;
  localCurrency?: Array<string>;
  proposalAmount?: number;
  proposalAmountInEuro?: number;
  proposalDate?: string;
  proposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  specialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  specialPaymentCompensationType?: Array<'Unknown' | 'Cash' | 'Equity'>;
  templateLetterName?: Array<string>;
  unpublishLetterBatch?: UnpublishLetterBatch;
}

export interface CommunicationsPartnerCreateLetterBatchLettersParams {
  id?: Array<string>;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  orgClusterNodeName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  letterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  templateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  processStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  recordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  workflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  template?: Array<string>;
  isDesignReady?: boolean;
  payoutDate?: string;
  payoutState?: Array<'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  seasonId?: string;
  workflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  multiplier?: number;
  overallTargetAchievement?: number;
  payoutAmount?: number;
  payoutCurrency?: Array<string>;
  ippAchievementValue?: string;
  incentivePaymentType?: Array<string>;
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  measurementDate?: string;
  meritTitle?: Array<string>;
  equityTitle?: Array<string>;
  equitySubTitle?: Array<string>;
  manuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  newHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  promotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  termination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  populationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  lineManagerFirstName?: Array<string>;
  lineManagerLastName?: Array<string>;
  companyManagerFirstName?: Array<string>;
  companyManagerGid?: Array<string>;
  companyManagerLastName?: Array<string>;
  templateName?: Array<string>;
  workflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  autoApprove?: boolean;
  approvalRequired?: boolean;
  letterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  processState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  exportState?: Array<'Open' | 'Done'>;
  payrollState?: Array<'Open' | 'Done'>;
  meritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  approvedByCompanyManager?: boolean;
  allocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  readyToPayroll?: boolean;
  equityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  hasOtpIncrease?: boolean;
  isOtpOnly?: boolean;
  planTitle?: Array<string>;
  localCurrency?: Array<string>;
  proposalAmount?: number;
  proposalAmountInEuro?: number;
  proposalDate?: string;
  proposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  specialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  specialPaymentCompensationType?: Array<'Unknown' | 'Cash' | 'Equity'>;
  templateLetterName?: Array<string>;
  createLetterBatch?: CreateLetterBatch;
}

export interface CommunicationsPartnerCreateManyLettersParams {
  createLetterBulk?: CreateLetterBulk;
}

export interface CommunicationsPartnerListUnpublishLetterLetterPublicationsParams {
  unpublishLetterList?: UnpublishLetterList;
}

export interface CommunicationsPartnerPublishLetterBatchLetterPublicationsParams {
  id?: Array<string>;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  orgClusterNodeName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  letterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  templateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  processStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  recordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  workflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  template?: Array<string>;
  isDesignReady?: boolean;
  payoutDate?: string;
  payoutState?: Array<'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  seasonId?: string;
  workflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  multiplier?: number;
  overallTargetAchievement?: number;
  payoutAmount?: number;
  payoutCurrency?: Array<string>;
  ippAchievementValue?: string;
  incentivePaymentType?: Array<string>;
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  measurementDate?: string;
  meritTitle?: Array<string>;
  equityTitle?: Array<string>;
  equitySubTitle?: Array<string>;
  manuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  newHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  promotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  termination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  populationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  lineManagerFirstName?: Array<string>;
  lineManagerLastName?: Array<string>;
  companyManagerFirstName?: Array<string>;
  companyManagerGid?: Array<string>;
  companyManagerLastName?: Array<string>;
  templateName?: Array<string>;
  workflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  autoApprove?: boolean;
  approvalRequired?: boolean;
  letterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  processState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  exportState?: Array<'Open' | 'Done'>;
  payrollState?: Array<'Open' | 'Done'>;
  meritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  approvedByCompanyManager?: boolean;
  allocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  readyToPayroll?: boolean;
  equityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  hasOtpIncrease?: boolean;
  isOtpOnly?: boolean;
  planTitle?: Array<string>;
  localCurrency?: Array<string>;
  proposalAmount?: number;
  proposalAmountInEuro?: number;
  proposalDate?: string;
  proposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  specialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  specialPaymentCompensationType?: Array<'Unknown' | 'Cash' | 'Equity'>;
  templateLetterName?: Array<string>;
  publishLetterBatch?: PublishLetterBatch;
}

export interface CommunicationsPartnerPublishLetterListLetterPublicationsParams {
  publishLetterList?: PublishLetterList;
}

export interface CommunicationsPartnerQueryLetterTemplatesParams {
  queryTitle?: string;
  queryDescription?: string;
  queryLetterType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  queryState?: 'Created' | 'Published' | 'Archived';
  queryCreatedBy?: string;
  queryUpdatedBy?: string;
  queryCreatedAt?: string;
  queryUpdatedAt?: string;
  queryCreatedAtFrom?: string;
  queryCreatedAtTo?: string;
  queryUpdatedAtFrom?: string;
  queryUpdatedAtTo?: string;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface ForwardLettersByQueryLetterActionsParams {
  id?: Array<string>;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  orgClusterNodeName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  letterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  templateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  processStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  recordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  workflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  template?: Array<string>;
  isDesignReady?: boolean;
  payoutDate?: string;
  payoutState?: Array<'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  seasonId?: string;
  workflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  multiplier?: number;
  overallTargetAchievement?: number;
  payoutAmount?: number;
  payoutCurrency?: Array<string>;
  ippAchievementValue?: string;
  incentivePaymentType?: Array<string>;
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  measurementDate?: string;
  meritTitle?: Array<string>;
  equityTitle?: Array<string>;
  equitySubTitle?: Array<string>;
  manuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  newHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  promotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  termination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  populationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  lineManagerFirstName?: Array<string>;
  lineManagerLastName?: Array<string>;
  companyManagerFirstName?: Array<string>;
  companyManagerGid?: Array<string>;
  companyManagerLastName?: Array<string>;
  templateName?: Array<string>;
  workflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  autoApprove?: boolean;
  approvalRequired?: boolean;
  letterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  processState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  exportState?: Array<'Open' | 'Done'>;
  payrollState?: Array<'Open' | 'Done'>;
  meritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  approvedByCompanyManager?: boolean;
  allocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  readyToPayroll?: boolean;
  equityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  hasOtpIncrease?: boolean;
  isOtpOnly?: boolean;
  planTitle?: Array<string>;
  localCurrency?: Array<string>;
  proposalAmount?: number;
  proposalAmountInEuro?: number;
  proposalDate?: string;
  proposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  specialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  specialPaymentCompensationType?: Array<'Unknown' | 'Cash' | 'Equity'>;
  templateLetterName?: Array<string>;
  forwardLetters?: ForwardLetters;
}

export interface ForwardLettersLetterActionsParams {
  forwardLetters?: ForwardLetters;
}

@Injectable({
  providedIn: 'root'
})
export class CommunicationsPartnerService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public communicationsPartnerAutoFinalizeLettersByQueryLetterFinalization(
    requestParameters?: CommunicationsPartnerAutoFinalizeLettersByQueryLetterFinalizationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public communicationsPartnerAutoFinalizeLettersByQueryLetterFinalization(
    requestParameters?: CommunicationsPartnerAutoFinalizeLettersByQueryLetterFinalizationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsPartnerAutoFinalizeLettersByQueryLetterFinalization(
    requestParameters?: CommunicationsPartnerAutoFinalizeLettersByQueryLetterFinalizationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsPartnerAutoFinalizeLettersByQueryLetterFinalization(
    requestParameters?: CommunicationsPartnerAutoFinalizeLettersByQueryLetterFinalizationParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/partner/api/v1/master/letters/batch/finalization`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Id: requestParameters?.id,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        OrgClusterNodeName: requestParameters?.orgClusterNodeName,
        State: requestParameters?.state,
        PlanName: requestParameters?.planName,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        AssignmentId: requestParameters?.assignmentId,
        LetterType: requestParameters?.letterType,
        TemplateType: requestParameters?.templateType,
        ProcessStates: requestParameters?.processStates,
        RecordCommunicationStates: requestParameters?.recordCommunicationStates,
        Workflow: requestParameters?.workflow,
        Template: requestParameters?.template,
        IsDesignReady: requestParameters?.isDesignReady,
        PayoutDate: requestParameters?.payoutDate,
        PayoutState: requestParameters?.payoutState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        SeasonId: requestParameters?.seasonId,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        Multiplier: requestParameters?.multiplier,
        OverallTargetAchievement: requestParameters?.overallTargetAchievement,
        PayoutAmount: requestParameters?.payoutAmount,
        PayoutCurrency: requestParameters?.payoutCurrency,
        IppAchievementValue: requestParameters?.ippAchievementValue,
        IncentivePaymentType: requestParameters?.incentivePaymentType,
        ContractStatus: requestParameters?.contractStatus,
        MeasurementDate: requestParameters?.measurementDate,
        MeritTitle: requestParameters?.meritTitle,
        EquityTitle: requestParameters?.equityTitle,
        EquitySubTitle: requestParameters?.equitySubTitle,
        ManuallyChanged: requestParameters?.manuallyChanged,
        NewHire: requestParameters?.newHire,
        Promotion: requestParameters?.promotion,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        LineManagerFirstName: requestParameters?.lineManagerFirstName,
        LineManagerLastName: requestParameters?.lineManagerLastName,
        CompanyManagerFirstName: requestParameters?.companyManagerFirstName,
        CompanyManagerGid: requestParameters?.companyManagerGid,
        CompanyManagerLastName: requestParameters?.companyManagerLastName,
        TemplateName: requestParameters?.templateName,
        WorkflowType: requestParameters?.workflowType,
        AutoApprove: requestParameters?.autoApprove,
        ApprovalRequired: requestParameters?.approvalRequired,
        LetterState: requestParameters?.letterState,
        ProcessState: requestParameters?.processState,
        ExportState: requestParameters?.exportState,
        PayrollState: requestParameters?.payrollState,
        MeritRelevancy: requestParameters?.meritRelevancy,
        ApprovedByCompanyManager: requestParameters?.approvedByCompanyManager,
        AllocationWorkflowType: requestParameters?.allocationWorkflowType,
        ReadyToPayroll: requestParameters?.readyToPayroll,
        EquityRelevancy: requestParameters?.equityRelevancy,
        HasOtpIncrease: requestParameters?.hasOtpIncrease,
        IsOtpOnly: requestParameters?.isOtpOnly,
        PlanTitle: requestParameters?.planTitle,
        LocalCurrency: requestParameters?.localCurrency,
        ProposalAmount: requestParameters?.proposalAmount,
        ProposalAmountInEuro: requestParameters?.proposalAmountInEuro,
        ProposalDate: requestParameters?.proposalDate,
        ProposalState: requestParameters?.proposalState,
        SpecialPaymentReason: requestParameters?.specialPaymentReason,
        SpecialPaymentCompensationType: requestParameters?.specialPaymentCompensationType,
        TemplateLetterName: requestParameters?.templateLetterName
      },
      body: requestParameters?.autoFinalizeLettersByQuery,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public communicationsPartnerAutoFinalizeLettersLetterFinalization(
    requestParameters?: CommunicationsPartnerAutoFinalizeLettersLetterFinalizationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public communicationsPartnerAutoFinalizeLettersLetterFinalization(
    requestParameters?: CommunicationsPartnerAutoFinalizeLettersLetterFinalizationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsPartnerAutoFinalizeLettersLetterFinalization(
    requestParameters?: CommunicationsPartnerAutoFinalizeLettersLetterFinalizationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsPartnerAutoFinalizeLettersLetterFinalization(
    requestParameters?: CommunicationsPartnerAutoFinalizeLettersLetterFinalizationParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/partner/api/v1/master/letters/list/finalization`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.autoFinalizeLetters,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public communicationsPartnerBatchDownloadByQueryLetters(
    requestParameters?: CommunicationsPartnerBatchDownloadByQueryLettersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public communicationsPartnerBatchDownloadByQueryLetters(
    requestParameters?: CommunicationsPartnerBatchDownloadByQueryLettersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsPartnerBatchDownloadByQueryLetters(
    requestParameters?: CommunicationsPartnerBatchDownloadByQueryLettersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsPartnerBatchDownloadByQueryLetters(
    requestParameters?: CommunicationsPartnerBatchDownloadByQueryLettersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/partner/api/v1/master/letters/batch/download`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Id: requestParameters?.id,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        OrgClusterNodeName: requestParameters?.orgClusterNodeName,
        State: requestParameters?.state,
        PlanName: requestParameters?.planName,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        AssignmentId: requestParameters?.assignmentId,
        LetterType: requestParameters?.letterType,
        TemplateType: requestParameters?.templateType,
        ProcessStates: requestParameters?.processStates,
        RecordCommunicationStates: requestParameters?.recordCommunicationStates,
        Workflow: requestParameters?.workflow,
        Template: requestParameters?.template,
        IsDesignReady: requestParameters?.isDesignReady,
        PayoutDate: requestParameters?.payoutDate,
        PayoutState: requestParameters?.payoutState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        SeasonId: requestParameters?.seasonId,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        Multiplier: requestParameters?.multiplier,
        OverallTargetAchievement: requestParameters?.overallTargetAchievement,
        PayoutAmount: requestParameters?.payoutAmount,
        PayoutCurrency: requestParameters?.payoutCurrency,
        IppAchievementValue: requestParameters?.ippAchievementValue,
        IncentivePaymentType: requestParameters?.incentivePaymentType,
        ContractStatus: requestParameters?.contractStatus,
        MeasurementDate: requestParameters?.measurementDate,
        MeritTitle: requestParameters?.meritTitle,
        EquityTitle: requestParameters?.equityTitle,
        EquitySubTitle: requestParameters?.equitySubTitle,
        ManuallyChanged: requestParameters?.manuallyChanged,
        NewHire: requestParameters?.newHire,
        Promotion: requestParameters?.promotion,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        LineManagerFirstName: requestParameters?.lineManagerFirstName,
        LineManagerLastName: requestParameters?.lineManagerLastName,
        CompanyManagerFirstName: requestParameters?.companyManagerFirstName,
        CompanyManagerGid: requestParameters?.companyManagerGid,
        CompanyManagerLastName: requestParameters?.companyManagerLastName,
        TemplateName: requestParameters?.templateName,
        WorkflowType: requestParameters?.workflowType,
        AutoApprove: requestParameters?.autoApprove,
        ApprovalRequired: requestParameters?.approvalRequired,
        LetterState: requestParameters?.letterState,
        ProcessState: requestParameters?.processState,
        ExportState: requestParameters?.exportState,
        PayrollState: requestParameters?.payrollState,
        MeritRelevancy: requestParameters?.meritRelevancy,
        ApprovedByCompanyManager: requestParameters?.approvedByCompanyManager,
        AllocationWorkflowType: requestParameters?.allocationWorkflowType,
        ReadyToPayroll: requestParameters?.readyToPayroll,
        EquityRelevancy: requestParameters?.equityRelevancy,
        HasOtpIncrease: requestParameters?.hasOtpIncrease,
        IsOtpOnly: requestParameters?.isOtpOnly,
        PlanTitle: requestParameters?.planTitle,
        LocalCurrency: requestParameters?.localCurrency,
        ProposalAmount: requestParameters?.proposalAmount,
        ProposalAmountInEuro: requestParameters?.proposalAmountInEuro,
        ProposalDate: requestParameters?.proposalDate,
        ProposalState: requestParameters?.proposalState,
        SpecialPaymentReason: requestParameters?.specialPaymentReason,
        SpecialPaymentCompensationType: requestParameters?.specialPaymentCompensationType,
        TemplateLetterName: requestParameters?.templateLetterName
      },
      body: requestParameters?.downloadLetters,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public communicationsPartnerBatchUnpublishLetterLetterPublications(
    requestParameters?: CommunicationsPartnerBatchUnpublishLetterLetterPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public communicationsPartnerBatchUnpublishLetterLetterPublications(
    requestParameters?: CommunicationsPartnerBatchUnpublishLetterLetterPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsPartnerBatchUnpublishLetterLetterPublications(
    requestParameters?: CommunicationsPartnerBatchUnpublishLetterLetterPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsPartnerBatchUnpublishLetterLetterPublications(
    requestParameters?: CommunicationsPartnerBatchUnpublishLetterLetterPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/partner/api/v1/master/letters/batch/unpublish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Id: requestParameters?.id,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        OrgClusterNodeName: requestParameters?.orgClusterNodeName,
        State: requestParameters?.state,
        PlanName: requestParameters?.planName,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        AssignmentId: requestParameters?.assignmentId,
        LetterType: requestParameters?.letterType,
        TemplateType: requestParameters?.templateType,
        ProcessStates: requestParameters?.processStates,
        RecordCommunicationStates: requestParameters?.recordCommunicationStates,
        Workflow: requestParameters?.workflow,
        Template: requestParameters?.template,
        IsDesignReady: requestParameters?.isDesignReady,
        PayoutDate: requestParameters?.payoutDate,
        PayoutState: requestParameters?.payoutState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        SeasonId: requestParameters?.seasonId,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        Multiplier: requestParameters?.multiplier,
        OverallTargetAchievement: requestParameters?.overallTargetAchievement,
        PayoutAmount: requestParameters?.payoutAmount,
        PayoutCurrency: requestParameters?.payoutCurrency,
        IppAchievementValue: requestParameters?.ippAchievementValue,
        IncentivePaymentType: requestParameters?.incentivePaymentType,
        ContractStatus: requestParameters?.contractStatus,
        MeasurementDate: requestParameters?.measurementDate,
        MeritTitle: requestParameters?.meritTitle,
        EquityTitle: requestParameters?.equityTitle,
        EquitySubTitle: requestParameters?.equitySubTitle,
        ManuallyChanged: requestParameters?.manuallyChanged,
        NewHire: requestParameters?.newHire,
        Promotion: requestParameters?.promotion,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        LineManagerFirstName: requestParameters?.lineManagerFirstName,
        LineManagerLastName: requestParameters?.lineManagerLastName,
        CompanyManagerFirstName: requestParameters?.companyManagerFirstName,
        CompanyManagerGid: requestParameters?.companyManagerGid,
        CompanyManagerLastName: requestParameters?.companyManagerLastName,
        TemplateName: requestParameters?.templateName,
        WorkflowType: requestParameters?.workflowType,
        AutoApprove: requestParameters?.autoApprove,
        ApprovalRequired: requestParameters?.approvalRequired,
        LetterState: requestParameters?.letterState,
        ProcessState: requestParameters?.processState,
        ExportState: requestParameters?.exportState,
        PayrollState: requestParameters?.payrollState,
        MeritRelevancy: requestParameters?.meritRelevancy,
        ApprovedByCompanyManager: requestParameters?.approvedByCompanyManager,
        AllocationWorkflowType: requestParameters?.allocationWorkflowType,
        ReadyToPayroll: requestParameters?.readyToPayroll,
        EquityRelevancy: requestParameters?.equityRelevancy,
        HasOtpIncrease: requestParameters?.hasOtpIncrease,
        IsOtpOnly: requestParameters?.isOtpOnly,
        PlanTitle: requestParameters?.planTitle,
        LocalCurrency: requestParameters?.localCurrency,
        ProposalAmount: requestParameters?.proposalAmount,
        ProposalAmountInEuro: requestParameters?.proposalAmountInEuro,
        ProposalDate: requestParameters?.proposalDate,
        ProposalState: requestParameters?.proposalState,
        SpecialPaymentReason: requestParameters?.specialPaymentReason,
        SpecialPaymentCompensationType: requestParameters?.specialPaymentCompensationType,
        TemplateLetterName: requestParameters?.templateLetterName
      },
      body: requestParameters?.unpublishLetterBatch,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public communicationsPartnerCreateLetterBatchLetters(
    requestParameters?: CommunicationsPartnerCreateLetterBatchLettersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public communicationsPartnerCreateLetterBatchLetters(
    requestParameters?: CommunicationsPartnerCreateLetterBatchLettersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsPartnerCreateLetterBatchLetters(
    requestParameters?: CommunicationsPartnerCreateLetterBatchLettersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsPartnerCreateLetterBatchLetters(
    requestParameters?: CommunicationsPartnerCreateLetterBatchLettersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/partner/api/v1/master/letters/batch`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Id: requestParameters?.id,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        OrgClusterNodeName: requestParameters?.orgClusterNodeName,
        State: requestParameters?.state,
        PlanName: requestParameters?.planName,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        AssignmentId: requestParameters?.assignmentId,
        LetterType: requestParameters?.letterType,
        TemplateType: requestParameters?.templateType,
        ProcessStates: requestParameters?.processStates,
        RecordCommunicationStates: requestParameters?.recordCommunicationStates,
        Workflow: requestParameters?.workflow,
        Template: requestParameters?.template,
        IsDesignReady: requestParameters?.isDesignReady,
        PayoutDate: requestParameters?.payoutDate,
        PayoutState: requestParameters?.payoutState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        SeasonId: requestParameters?.seasonId,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        Multiplier: requestParameters?.multiplier,
        OverallTargetAchievement: requestParameters?.overallTargetAchievement,
        PayoutAmount: requestParameters?.payoutAmount,
        PayoutCurrency: requestParameters?.payoutCurrency,
        IppAchievementValue: requestParameters?.ippAchievementValue,
        IncentivePaymentType: requestParameters?.incentivePaymentType,
        ContractStatus: requestParameters?.contractStatus,
        MeasurementDate: requestParameters?.measurementDate,
        MeritTitle: requestParameters?.meritTitle,
        EquityTitle: requestParameters?.equityTitle,
        EquitySubTitle: requestParameters?.equitySubTitle,
        ManuallyChanged: requestParameters?.manuallyChanged,
        NewHire: requestParameters?.newHire,
        Promotion: requestParameters?.promotion,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        LineManagerFirstName: requestParameters?.lineManagerFirstName,
        LineManagerLastName: requestParameters?.lineManagerLastName,
        CompanyManagerFirstName: requestParameters?.companyManagerFirstName,
        CompanyManagerGid: requestParameters?.companyManagerGid,
        CompanyManagerLastName: requestParameters?.companyManagerLastName,
        TemplateName: requestParameters?.templateName,
        WorkflowType: requestParameters?.workflowType,
        AutoApprove: requestParameters?.autoApprove,
        ApprovalRequired: requestParameters?.approvalRequired,
        LetterState: requestParameters?.letterState,
        ProcessState: requestParameters?.processState,
        ExportState: requestParameters?.exportState,
        PayrollState: requestParameters?.payrollState,
        MeritRelevancy: requestParameters?.meritRelevancy,
        ApprovedByCompanyManager: requestParameters?.approvedByCompanyManager,
        AllocationWorkflowType: requestParameters?.allocationWorkflowType,
        ReadyToPayroll: requestParameters?.readyToPayroll,
        EquityRelevancy: requestParameters?.equityRelevancy,
        HasOtpIncrease: requestParameters?.hasOtpIncrease,
        IsOtpOnly: requestParameters?.isOtpOnly,
        PlanTitle: requestParameters?.planTitle,
        LocalCurrency: requestParameters?.localCurrency,
        ProposalAmount: requestParameters?.proposalAmount,
        ProposalAmountInEuro: requestParameters?.proposalAmountInEuro,
        ProposalDate: requestParameters?.proposalDate,
        ProposalState: requestParameters?.proposalState,
        SpecialPaymentReason: requestParameters?.specialPaymentReason,
        SpecialPaymentCompensationType: requestParameters?.specialPaymentCompensationType,
        TemplateLetterName: requestParameters?.templateLetterName
      },
      body: requestParameters?.createLetterBatch,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public communicationsPartnerCreateManyLetters(
    requestParameters?: CommunicationsPartnerCreateManyLettersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public communicationsPartnerCreateManyLetters(
    requestParameters?: CommunicationsPartnerCreateManyLettersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsPartnerCreateManyLetters(
    requestParameters?: CommunicationsPartnerCreateManyLettersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsPartnerCreateManyLetters(
    requestParameters?: CommunicationsPartnerCreateManyLettersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/partner/api/v1/master/letters/list`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createLetterBulk,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public communicationsPartnerListUnpublishLetterLetterPublications(
    requestParameters?: CommunicationsPartnerListUnpublishLetterLetterPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public communicationsPartnerListUnpublishLetterLetterPublications(
    requestParameters?: CommunicationsPartnerListUnpublishLetterLetterPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsPartnerListUnpublishLetterLetterPublications(
    requestParameters?: CommunicationsPartnerListUnpublishLetterLetterPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsPartnerListUnpublishLetterLetterPublications(
    requestParameters?: CommunicationsPartnerListUnpublishLetterLetterPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/partner/api/v1/master/letters/list/unpublish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.unpublishLetterList,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public communicationsPartnerPublishLetterBatchLetterPublications(
    requestParameters?: CommunicationsPartnerPublishLetterBatchLetterPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public communicationsPartnerPublishLetterBatchLetterPublications(
    requestParameters?: CommunicationsPartnerPublishLetterBatchLetterPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsPartnerPublishLetterBatchLetterPublications(
    requestParameters?: CommunicationsPartnerPublishLetterBatchLetterPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsPartnerPublishLetterBatchLetterPublications(
    requestParameters?: CommunicationsPartnerPublishLetterBatchLetterPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/partner/api/v1/master/letters/batch/publish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Id: requestParameters?.id,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        OrgClusterNodeName: requestParameters?.orgClusterNodeName,
        State: requestParameters?.state,
        PlanName: requestParameters?.planName,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        AssignmentId: requestParameters?.assignmentId,
        LetterType: requestParameters?.letterType,
        TemplateType: requestParameters?.templateType,
        ProcessStates: requestParameters?.processStates,
        RecordCommunicationStates: requestParameters?.recordCommunicationStates,
        Workflow: requestParameters?.workflow,
        Template: requestParameters?.template,
        IsDesignReady: requestParameters?.isDesignReady,
        PayoutDate: requestParameters?.payoutDate,
        PayoutState: requestParameters?.payoutState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        SeasonId: requestParameters?.seasonId,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        Multiplier: requestParameters?.multiplier,
        OverallTargetAchievement: requestParameters?.overallTargetAchievement,
        PayoutAmount: requestParameters?.payoutAmount,
        PayoutCurrency: requestParameters?.payoutCurrency,
        IppAchievementValue: requestParameters?.ippAchievementValue,
        IncentivePaymentType: requestParameters?.incentivePaymentType,
        ContractStatus: requestParameters?.contractStatus,
        MeasurementDate: requestParameters?.measurementDate,
        MeritTitle: requestParameters?.meritTitle,
        EquityTitle: requestParameters?.equityTitle,
        EquitySubTitle: requestParameters?.equitySubTitle,
        ManuallyChanged: requestParameters?.manuallyChanged,
        NewHire: requestParameters?.newHire,
        Promotion: requestParameters?.promotion,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        LineManagerFirstName: requestParameters?.lineManagerFirstName,
        LineManagerLastName: requestParameters?.lineManagerLastName,
        CompanyManagerFirstName: requestParameters?.companyManagerFirstName,
        CompanyManagerGid: requestParameters?.companyManagerGid,
        CompanyManagerLastName: requestParameters?.companyManagerLastName,
        TemplateName: requestParameters?.templateName,
        WorkflowType: requestParameters?.workflowType,
        AutoApprove: requestParameters?.autoApprove,
        ApprovalRequired: requestParameters?.approvalRequired,
        LetterState: requestParameters?.letterState,
        ProcessState: requestParameters?.processState,
        ExportState: requestParameters?.exportState,
        PayrollState: requestParameters?.payrollState,
        MeritRelevancy: requestParameters?.meritRelevancy,
        ApprovedByCompanyManager: requestParameters?.approvedByCompanyManager,
        AllocationWorkflowType: requestParameters?.allocationWorkflowType,
        ReadyToPayroll: requestParameters?.readyToPayroll,
        EquityRelevancy: requestParameters?.equityRelevancy,
        HasOtpIncrease: requestParameters?.hasOtpIncrease,
        IsOtpOnly: requestParameters?.isOtpOnly,
        PlanTitle: requestParameters?.planTitle,
        LocalCurrency: requestParameters?.localCurrency,
        ProposalAmount: requestParameters?.proposalAmount,
        ProposalAmountInEuro: requestParameters?.proposalAmountInEuro,
        ProposalDate: requestParameters?.proposalDate,
        ProposalState: requestParameters?.proposalState,
        SpecialPaymentReason: requestParameters?.specialPaymentReason,
        SpecialPaymentCompensationType: requestParameters?.specialPaymentCompensationType,
        TemplateLetterName: requestParameters?.templateLetterName
      },
      body: requestParameters?.publishLetterBatch,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public communicationsPartnerPublishLetterListLetterPublications(
    requestParameters?: CommunicationsPartnerPublishLetterListLetterPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public communicationsPartnerPublishLetterListLetterPublications(
    requestParameters?: CommunicationsPartnerPublishLetterListLetterPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsPartnerPublishLetterListLetterPublications(
    requestParameters?: CommunicationsPartnerPublishLetterListLetterPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsPartnerPublishLetterListLetterPublications(
    requestParameters?: CommunicationsPartnerPublishLetterListLetterPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/partner/api/v1/master/letters/list/publish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.publishLetterList,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public communicationsPartnerQueryLetterTemplates(
    requestParameters?: CommunicationsPartnerQueryLetterTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfWorkflowTemplate>;
  public communicationsPartnerQueryLetterTemplates(
    requestParameters?: CommunicationsPartnerQueryLetterTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfWorkflowTemplate>>;
  public communicationsPartnerQueryLetterTemplates(
    requestParameters?: CommunicationsPartnerQueryLetterTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfWorkflowTemplate>>;
  public communicationsPartnerQueryLetterTemplates(
    requestParameters?: CommunicationsPartnerQueryLetterTemplatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/partner/api/v1/master/letters/templates`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.Title': requestParameters?.queryTitle,
        'Query.Description': requestParameters?.queryDescription,
        'Query.LetterType': requestParameters?.queryLetterType,
        'Query.State': requestParameters?.queryState,
        'Query.CreatedBy': requestParameters?.queryCreatedBy,
        'Query.UpdatedBy': requestParameters?.queryUpdatedBy,
        'Query.CreatedAt': requestParameters?.queryCreatedAt,
        'Query.UpdatedAt': requestParameters?.queryUpdatedAt,
        'Query.CreatedAtFrom': requestParameters?.queryCreatedAtFrom,
        'Query.CreatedAtTo': requestParameters?.queryCreatedAtTo,
        'Query.UpdatedAtFrom': requestParameters?.queryUpdatedAtFrom,
        'Query.UpdatedAtTo': requestParameters?.queryUpdatedAtTo,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public forwardLettersByQueryLetterActions(
    requestParameters?: ForwardLettersByQueryLetterActionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public forwardLettersByQueryLetterActions(
    requestParameters?: ForwardLettersByQueryLetterActionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public forwardLettersByQueryLetterActions(
    requestParameters?: ForwardLettersByQueryLetterActionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public forwardLettersByQueryLetterActions(
    requestParameters?: ForwardLettersByQueryLetterActionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/partner/api/v1/master/letters/batch/forward`,
      accepts: [],
      query: {
        Id: requestParameters?.id,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        OrgClusterNodeName: requestParameters?.orgClusterNodeName,
        State: requestParameters?.state,
        PlanName: requestParameters?.planName,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        AssignmentId: requestParameters?.assignmentId,
        LetterType: requestParameters?.letterType,
        TemplateType: requestParameters?.templateType,
        ProcessStates: requestParameters?.processStates,
        RecordCommunicationStates: requestParameters?.recordCommunicationStates,
        Workflow: requestParameters?.workflow,
        Template: requestParameters?.template,
        IsDesignReady: requestParameters?.isDesignReady,
        PayoutDate: requestParameters?.payoutDate,
        PayoutState: requestParameters?.payoutState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        SeasonId: requestParameters?.seasonId,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        Multiplier: requestParameters?.multiplier,
        OverallTargetAchievement: requestParameters?.overallTargetAchievement,
        PayoutAmount: requestParameters?.payoutAmount,
        PayoutCurrency: requestParameters?.payoutCurrency,
        IppAchievementValue: requestParameters?.ippAchievementValue,
        IncentivePaymentType: requestParameters?.incentivePaymentType,
        ContractStatus: requestParameters?.contractStatus,
        MeasurementDate: requestParameters?.measurementDate,
        MeritTitle: requestParameters?.meritTitle,
        EquityTitle: requestParameters?.equityTitle,
        EquitySubTitle: requestParameters?.equitySubTitle,
        ManuallyChanged: requestParameters?.manuallyChanged,
        NewHire: requestParameters?.newHire,
        Promotion: requestParameters?.promotion,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        LineManagerFirstName: requestParameters?.lineManagerFirstName,
        LineManagerLastName: requestParameters?.lineManagerLastName,
        CompanyManagerFirstName: requestParameters?.companyManagerFirstName,
        CompanyManagerGid: requestParameters?.companyManagerGid,
        CompanyManagerLastName: requestParameters?.companyManagerLastName,
        TemplateName: requestParameters?.templateName,
        WorkflowType: requestParameters?.workflowType,
        AutoApprove: requestParameters?.autoApprove,
        ApprovalRequired: requestParameters?.approvalRequired,
        LetterState: requestParameters?.letterState,
        ProcessState: requestParameters?.processState,
        ExportState: requestParameters?.exportState,
        PayrollState: requestParameters?.payrollState,
        MeritRelevancy: requestParameters?.meritRelevancy,
        ApprovedByCompanyManager: requestParameters?.approvedByCompanyManager,
        AllocationWorkflowType: requestParameters?.allocationWorkflowType,
        ReadyToPayroll: requestParameters?.readyToPayroll,
        EquityRelevancy: requestParameters?.equityRelevancy,
        HasOtpIncrease: requestParameters?.hasOtpIncrease,
        IsOtpOnly: requestParameters?.isOtpOnly,
        PlanTitle: requestParameters?.planTitle,
        LocalCurrency: requestParameters?.localCurrency,
        ProposalAmount: requestParameters?.proposalAmount,
        ProposalAmountInEuro: requestParameters?.proposalAmountInEuro,
        ProposalDate: requestParameters?.proposalDate,
        ProposalState: requestParameters?.proposalState,
        SpecialPaymentReason: requestParameters?.specialPaymentReason,
        SpecialPaymentCompensationType: requestParameters?.specialPaymentCompensationType,
        TemplateLetterName: requestParameters?.templateLetterName
      },
      body: requestParameters?.forwardLetters,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public forwardLettersLetterActions(
    requestParameters?: ForwardLettersLetterActionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public forwardLettersLetterActions(
    requestParameters?: ForwardLettersLetterActionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public forwardLettersLetterActions(
    requestParameters?: ForwardLettersLetterActionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public forwardLettersLetterActions(
    requestParameters?: ForwardLettersLetterActionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/partner/api/v1/master/letters/list/forward`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.forwardLetters,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
